import React from 'react';
import clsx from 'clsx';
import { Box } from '@wix/design-system';
import { WIX_HEADER_HEIGHT } from '@wix/core-domain-search';
import { BngSearchField, BngSearchFieldMobile } from '../../../../Components/BngSearchField';
import { useIsMobile } from '../../../../hooks/useIsMobile';
import pageStyles from '../../../anonymousResultsPage.scss';
export const DESKTOP_STICKY_SEARCH_TOP_GAP = '28px';
export const BngResultsPageShell = _ref => {
  let layout = _ref.layout,
    header = _ref.header,
    searchField = _ref.searchField,
    stickyHeaderRef = _ref.stickyHeaderRef,
    clipHorizontalOverflow = _ref.clipHorizontalOverflow,
    children = _ref.children;
  const isMobile = useIsMobile();
  const SearchField = isMobile ? BngSearchFieldMobile : BngSearchField;
  return /*#__PURE__*/React.createElement(Box, {
    display: "block",
    boxSizing: "border-box",
    width: "100%",
    className: clipHorizontalOverflow ? pageStyles.bngSwipeClip : undefined
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    className: clsx(pageStyles.resultsPage, pageStyles.noInsights, pageStyles.withNames, layout.className),
    gap: isMobile ? 0 : 'SP6 0',
    height: "100%",
    backgroundColor: "white",
    overflow: "visible",
    paddingTop: layout.pagePaddingTop,
    paddingBottom: "SP5",
    paddingLeft: layout.pagePaddingSides,
    paddingRight: layout.pagePaddingSides
  }, /*#__PURE__*/React.createElement(Box, {
    boxSizing: "border-box",
    align: "center",
    gridArea: "header",
    width: "100%",
    backgroundColor: "white",
    direction: "vertical",
    gap: "SP6",
    paddingBottom: layout.headerPaddingBottom
  }, header), /*#__PURE__*/React.createElement(Box, {
    ref: stickyHeaderRef,
    boxSizing: "border-box",
    align: "center",
    gridArea: "searchbar",
    top: WIX_HEADER_HEIGHT,
    position: "sticky",
    width: "100%",
    zIndex: 11,
    backgroundColor: "white",
    direction: "vertical",
    paddingTop: layout.stickyBarPaddingTop,
    paddingBottom: layout.stickyBarPaddingBottom,
    marginTop: isMobile ? undefined : `-${DESKTOP_STICKY_SEARCH_TOP_GAP}`,
    paddingLeft: layout.sectionPaddingSide,
    paddingRight: layout.sectionPaddingSide
  }, /*#__PURE__*/React.createElement("div", {
    className: pageStyles.centeredContent
  }, /*#__PURE__*/React.createElement(SearchField, searchField))), children));
};
//# sourceMappingURL=BngResultsPageShell.js.map